import { createFileRoute, notFound } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Ranks below every declared route, so it gets every URL no other route claims (`/apps` has its own, `apps/$.tsx`).
// Its `notFound()` renders `NotFoundPage` (`defaultNotFoundComponent`, `app/routerDefaults.tsx`) below the navbar.
// A route, because the router hands a URL that matches nothing to its deepest partial match, for `/foo` the root
// alone (`_authenticated` has no path): no sign-in redirect, no navbar. Through this route that layout's `beforeLoad`
// runs first. Not a `notFoundComponent` on `_authenticated` either: the router would render it in place of the shell.
//
// No access check, or an unknown URL would get `NotAuthorizedPage`; the `'home'` navbar gives a way out.
export const Route = createFileRoute('/_authenticated/$')({
    staticData: { access: 'authenticated', chrome: 'home' } satisfies PageStaticData,
    beforeLoad: () => {
        throw notFound();
    },
});
